import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloseQuote2: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="close-quote-2, blockquote">
      <path
        d="M10 5H3V13H6V19C6 19 10 17.5 10 13V5Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M21 5H14L13.9961 13H16.9961L17 19C17 19 21 17.5 21 13V5Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </CentralIconBase>
  );
};

export default IconCloseQuote2;
